import { Component, OnInit } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@models/permissions.enum";
import { filter } from "rxjs/operators";
import { FeatureFlagsService } from "@app/agilx/shared/feature-flags.service";

@Component({
  selector: "app-sidebar-component",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  isLogin: boolean = false;
  constructor(
    private router: Router,
    private _AuthService: authenticationService,
    private featureFlagsService: FeatureFlagsService
  ) {}
  isDis: boolean = false;

  ngOnInit() {
    const loginUrls = ["/login", "/reset"];
    if (loginUrls.some((url) => this.router.url.startsWith(url))) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: NavigationStart) => {
        this.isLogin = loginUrls.some((url) => event.url.startsWith(url));
      });
  }

  hasPermission(permissionName: string) {
    const permission = (Permissions as Record<string, any>)[permissionName];
    return this._AuthService.hasPermission(permission);
  }

  isFeatureEnabled(featureName: string): boolean {
    return this.featureFlagsService.isEnabled(featureName as any);
  }

  sliderFunctionality() {
    const sidebar = document.getElementById("navSidebar");
    if (!sidebar) return;
    const pageContainer = document.querySelector(".page-container") as HTMLElement;
    if (this.isDis == false) {
      this.isDis = true;
      sidebar.style.transform = "translate(210px, 0px)";
      if (pageContainer) {
        pageContainer.style.transform = "translateX(210px)";
      }
    } else {
      this.isDis = false;
      sidebar.style.transform = "translate3d(0px, 0px, 0px)";
      if (pageContainer) {
        pageContainer.style.transform = "";
      }
    }
  }
}
